import styled from 'styled-components';
import {
  scale020,
  scale060,
  scale080,
  scale090,
  scale100,
  xdlColorText,
} from '@xingternal/tokens';
import { mediaConfined, mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { AutoComplete } from '@xingternal/auto-complete';
import { Checkbox } from '@xingternal/checkbox';
import { Button } from '@xingternal/button';

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${scale080};

  @media ${mediaConfined} {
    flex-direction: row;
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  width: 100%;

  &:nth-child(2) {
    margin-top: ${scale080};
    margin-left: 0;
  }

  @media ${mediaConfined} {
    &:nth-child(2) {
      margin-left: ${scale060};
      margin-top: 0;
    }
  }
`;

export const StyledAutoComplete = styled(AutoComplete)`
  width: 100%;

  & input::placeholder {
    color: ${xdlColorText} !important;
  }
`;

export const StyledButton = styled(Button)`
  min-width: 134px;
  font-size: ${scale080};
  margin-left: ${scale060};

  @media ${mediaConfined} {
    min-width: 144px;
    font-size: ${scale090};
  }
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${scale080};
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;
  padding: ${scale060} ${scale100} ${scale060} ${scale020};
  font-size: ${scale080};
  cursor: pointer;

  ${({ $isJobsSearchVariantOneVersion }) =>
    $isJobsSearchVariantOneVersion &&
    `
    color: white;
  `}

  @media ${mediaSmallOrTiny} {
    &:nth-child(3), &:nth-child(4) {
      display: ${({ $lessFiltersHandheld }) =>
        $lessFiltersHandheld ? 'none' : 'flex'};
    }
  }
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-right: ${scale060};
  border-radius: 2px;

  ${({ $isJobsSearchVariantOneVersion }) =>
    $isJobsSearchVariantOneVersion &&
    `
    background-color: white;
  `}
`;
